import { useState } from "react";

const tourSlides = [
    {
        image: "/assets/tab_light_mode_add_tab.png",
        title: "Organize Your Tabs",
        description: "Group your tabs into collections for easy access and a clutter-free browser.",
    },
    {
        image: "/assets/note_light_mode.png",
        title: "Take Smart Notes",
        description: "Capture ideas, meeting notes, and todos right alongside your tabs.",
    },
];

export function FeatureTour({ showDescription = false }: { showDescription: boolean }) {
    const [index, setIndex] = useState(0);
    const slide = tourSlides[index];
    return (
        <div className="w-full h-full flex flex-col items-center justify-center">
            <div className="w-full max-w-2xl flex flex-col items-center justify-center">
                <div className="w-full rounded-xl shadow-2xl flex items-center justify-center mb-8 overflow-hidden">
                    <img
                        src={slide.image}
                        alt={slide.title}
                        className="w-full h-full object-contain"
                        style={{ maxHeight: "500px" }}
                    />
                </div>
                {
                    showDescription && (
                        <>
                            <h2 className="text-3xl font-bold mb-3 text-center">{slide.title}</h2>
                            <p className="text-muted-foreground mb-8 text-center text-lg">{slide.description}</p>
                        </>
                    )
                }

                <div className="flex gap-3 items-center justify-center mt-2">
                    {tourSlides.map((_, i) => (
                        <span
                            key={i}
                            className={`w-4 h-4 rounded-full transition-all duration-200 ${i === index ? 'bg-primary' : 'bg-muted-foreground/30'}`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setIndex(i)}
                        ></span>
                    ))}
                </div>
            </div>
        </div>
    );
}